import React, { FC } from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import TwoColumnsWithImage from 'shared/components/TwoColumnsWithImage';
import Container, { ContainerSize } from 'system/components/Container';

interface Props {
  containerSize?: ContainerSize | number;
}

export const CertificateSection: FC<Props> = ({ containerSize = 'md' }) => {
  const { t } = useTranslation('static_pages');

  return (
    <Container size={containerSize}>
      <TwoColumnsWithImage
        component="section"
        imagePosition="right"
        px={{ xs: 2, md: 4, lg: 0 }}
      >
        <TwoColumnsWithImage.Title>
          <Title>{t('marketingPages.certifiedSection.title')}</Title>
        </TwoColumnsWithImage.Title>
        <TwoColumnsWithImage.Image
          justifySelf={{ xs: 'center', md: 'end!important' }}
        >
          <Image
            alt=""
            height={337}
            width={473}
            objectFit="contain"
            src="/artifacts/images/marketing_pages/certified.webp"
          />
        </TwoColumnsWithImage.Image>
        <TwoColumnsWithImage.Description>
          <Description>
            {t('marketingPages.certifiedSection.description')}
          </Description>
        </TwoColumnsWithImage.Description>
      </TwoColumnsWithImage>
    </Container>
  );
};

const Title = styled.h3`
  padding: 0;
  margin: 0;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('md')} {
    text-align: start;
    font-size: 36px;
  }
`;

const Description = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 168%;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up('md')} {
    text-align: start;
  }
`;

export default CertificateSection;
